// extracted by mini-css-extract-plugin
module.exports = {"banner":"style-module--banner--1_a2Q","content":"style-module--content--1NCu0","buttonWrap":"style-module--buttonWrap--135FI"};